module.exports = __webpack_public_path__ + "img/linuxlogo.7e6ce952.png";